/** @file Converts a rig handle ([ax, ay, bx, by, cx?, cy?] image pixels) into slot-bone space. */
import { affine } from '@pose2d/math/affine';
import type { Affine } from '@pose2d/math/types';
import type { Handle } from '@pose2d/format/types';

/** Handle points mapped by toLocal (y-up slot-bone space); `c` only when the rig gives six numbers. */
export function handleToLocal(handle: readonly number[], toLocal: Affine): Handle {
  const point = (i: number): [number, number] => affine.apply(toLocal, handle[i] ?? 0, handle[i + 1] ?? 0, [0, 0]);
  return handle.length >= 6 ? { a: point(0), b: point(2), c: point(4) } : { a: point(0), b: point(2) };
}
